import {Component, OnInit, ViewChild} from '@angular/core';
import {Grid} from '../../../../shared/Models/grid';
import {Router} from '@angular/router';
import {ActionColumn, ActionItem, TextColumn} from '../../../../shared/Models/columns';
import {SystemUser} from '../../../../shared/Models/SystemUser';
import {TranslateService} from '@ngx-translate/core';
import {GeneralTermService} from '../../../Services/general-term.service';
import * as moment from 'moment';
import {AuthenticationService} from '../../../../shared/Services/authentication.service';

@Component({
  selector: 'app-general-terms-overview',
  templateUrl: './general-terms-overview.component.html',
  styleUrls: ['./general-terms-overview.component.scss']
})
export class GeneralTermsOverviewComponent implements OnInit {
  public grid: Grid;

  @ViewChild('usersRowDetail', {static: false}) usersRowDetail: any;

  constructor(private router: Router, private generalTermService: GeneralTermService, private translateService: TranslateService, private auth: AuthenticationService) {
  }

  ngOnInit() {
    const dateFormat = this.auth.getDateFormat();
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.general_terms.number',
          prop: 'id',
          sortable: true,
          type: TextColumn.type,
          width: 100,
          minWidth: 100,
          maxWidth: 100,
          translate: true
        },
        <TextColumn>{
          name: 'doctrine.general_terms.date',
          prop: 'createdAt',
          sortable: true,
          type: TextColumn.type,
          width: 100,
          minWidth: 100,
          maxWidth: 100,
          translate: true,
          valueFormatter: function (value) {
            return moment(value).format(dateFormat);
          }
        },
        <TextColumn>{
          name: 'doctrine.general_terms.file',
          prop: 'file.filename',
          sortable: false,
          type: TextColumn.type,
          width: 300,
          translate: true
        },
        <TextColumn>{
          name: 'doctrine.general_terms.comment',
          prop: 'comment',
          sortable: false,
          type: TextColumn.type,
          width: 300,
          translate: true
        },
        <TextColumn>{
          name: 'doctrine.general_terms.by',
          prop: 'user.contact',
          sortable: false,
          type: TextColumn.type,
          width: 200,
          translate: true
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          width: 100,
          minWidth: 100,
          maxWidth: 100,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-pencil fa-lg',
              tooltip: 'global.edit',
              onclick: row => this.router.navigateByUrl('back-office/terms/' + row.id),
              showCallback: row => row,
              btnClass: 'ripple light'
            }
          ]
        }
      ],
      service: this.generalTermService,
      rememberURL: this.router.url,
      method: 'getTermsList',
      defaultSort: 'id',
      rowDetailTemplate: this.usersRowDetail,
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: true
    };
  }
}
